import Vue from "vue"
import Vuex from "vuex"
import api from "@/services/api"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    page: {},

    site_id: "awass",
    s3: "https://s3.eu-west-2.amazonaws.com/a-wass-media/",
    settings: null,
    main_pages: null,
    obits: null,
    latest_obits: null,

    whensomeonediesPage: null,
    funeralPage: null,
    prepaidPage: null,
    newsPage: null,

    homeID: "axXAkFWz8",
    whensomeonediesID: "jMRbx2Dw-",
    funeralID: "-OQE7uEk8",
    prepaidID: "hwML3JoZ2",
    aboutID: "OMFmc8a3H",
    newsID: "unYyg5cKv",
    contactID: "zGnnMQf4S",
    obitID: "9u1lFVw1F"
  },
  getters: {
    isHomePage(state) {
      return state.page.ItemID && state.page.ItemID == state.homeID
    },
    isNewsPage(state) {
      return state.page.ItemID && state.page.ItemID == state.newsID
    },
    isWhenSomeoneDiesPage(state) {
      return state.page.ItemID && state.page.ItemID == state.whensomeonediesID
    },
    isContactPage(state) {
      return state.page.ItemID && state.page.ItemID == state.contactID
    },
    isObitsPage(state) {
      return state.page.ItemID && state.page.ItemID == state.obitID
    },
    isObit(state) {
      return state.page.SubItemType && state.page.SubItemType == "obituaries"
    }
  },
  mutations: {
    setPage(state, page) {
      state.page = page
    },
    setSettings(state, settings) {
      state.settings = settings
    },
    setMainPages(state, main_pages) {
      state.main_pages = main_pages
    },
    setObits(state, obits) {
      state.obits = obits
    },
    setLatestObits(state, latest_obits) {
      state.latest_obits = latest_obits
    }
  },
  actions: {
    getSettings({ commit, state }) {
      return new Promise(resolve => {
        if (!state.settings)
          api.getPageByItemID("SETTINGS").then(settings => {
            commit("setSettings", settings)
            resolve()
          })
        else resolve()
      })
    },
    getMainPages({ commit, state }) {
      return new Promise(resolve => {
        if (!state.main_pages)
          api.getPages("page.main").then(main_pages => {
            commit("setMainPages", main_pages)
            resolve()

            var promises = []

            main_pages.forEach(page => {
              if (page.ItemID == state.whensomeonediesID) state.whensomeonediesPage = page
              if (page.ItemID == state.funeralID) state.funeralPage = page
              if (page.ItemID == state.prepaidID) state.prepaidPage = page

              promises.push(
                api.getSubPages("page.sub", page.ItemID).then(subs => {
                  if (page.ItemID == state.aboutID)
                    subs.forEach(sub => {
                      if (sub.ItemID == state.newsID) state.newsPage = sub
                    })

                  Vue.set(page, "subs", subs)
                })
              )
            })

            Promise.all(promises).then(() => {
              commit("setMainPages", main_pages)
            })
          })
        else resolve()
      })
    },
    getObits({ commit, state }) {
      return new Promise(resolve => {
        if (!state.obits)
          api.getObituaries().then(obits => {
            commit("setLatestObits", JSON.parse(JSON.stringify(obits.slice(0, 3))))
            commit("setObits", obits)
            resolve()
          })
        else resolve()
      })
    }
  }
})
